import { useEffect } from "react"
import { useSignal } from "@preact/signals-react"
import { isEmpty, postSubmit } from "@ui-seeker/utils"

import { WEBBACK_V2_API } from "@constants"
import { useToast } from "@hooks"
import { historicalDataRowClick } from "../@signals"


export default function useHistorical() {
    
    const { showToast } = useToast()

    const historicalData = useSignal([])
    const isLoadingHistorical = useSignal(false)

    useEffect(() => {
        if (!isEmpty(historicalDataRowClick.value)) {
            isLoadingHistorical.value = true
            postSubmit(`${WEBBACK_V2_API}/reports/historical`, {
                reportID: historicalDataRowClick.value?.reportID
            }).then(res => {
                historicalData.value = res.historical
                isLoadingHistorical.value = false
            }).catch(() => {
                showToast.error()
                historicalData.value = []
                isLoadingHistorical.value = false
            })
        }
    }, [historicalDataRowClick.value])

    return {
        historicalData: historicalData.value,
        isLoadingHistorical: isLoadingHistorical.value
    }
}